module.exports = __webpack_public_path__ + "static/quiz4_question8-f9ed4c1671924f13c5f69671f2cc05ad.jpg";